import React from "react";
import { useLocation } from "react-router-dom";
import Tab, { TabGroup } from "@amzn/meridian/tab";
import Box from "@amzn/meridian/box";
import Heading from "@amzn/meridian/heading";
import Text from "@amzn/meridian/text";
import Button from "@amzn/meridian/button";
import Link from "@amzn/meridian/link";
import { useNavigationControl } from "../../hooks/useNavigationControl";
import { ROUTES } from "../../utils/constants";

import "./StationAssignmentTabs.scss";

interface TabItem {
  id: string;
  label: string;
  path: string;
}

const tabs: TabItem[] = [
  {
    id: "shift-roster",
    label: "1. Shift rotation",
    path: ROUTES.SHIFT_ROTATION_SHIFT_ROSTER,
  },
  {
    id: "assignments",
    label: "2. Assignments",
    path: ROUTES.SHIFT_ROTATION_ASSIGNMENTS,
  },
  {
    id: "review",
    label: "3. Review and Publish",
    path: ROUTES.SHIFT_ROTATION_REVIEW,
  },
];

export interface StationAssignmentTabsProps {
  date?: string;
  shiftType?: string;
  children: React.ReactNode;
}

const StationAssignmentTabs: React.FC<StationAssignmentTabsProps> = ({
  date,
  shiftType,
  children,
}) => {
  const { navigate } = useNavigationControl();
  const location = useLocation();

  const currentTab =
    tabs.find((tab) => tab.path === location.pathname)?.id ?? tabs[0].id;

  const handleTabChange = React.useCallback(
    (tabId: string) => {
      const selectedTab = tabs.find((tab) => tab.id === tabId);
      if (selectedTab) {
        navigate(selectedTab.path);
      }
    },
    [navigate]
  );

  return (
    <Box spacingInset="300" className="station-assignment-tabs">
      <Box className="station-assignment-header">
        <Box className="title-section">
          <Heading type="h400" level={2}>
            Station assignment
          </Heading>
        </Box>
        <Box className="header-actions">
          {date && shiftType && (
            <Text color="secondary" type="b200">
              {date}, {shiftType}
            </Text>
          )}
          <Link type="secondary">View history</Link>
          <Button type="tertiary" size="small">
            Site template
          </Button>
        </Box>
      </Box>

      <Box className="tabs-container">
        <TabGroup
          fill="line"
          value={currentTab}
          onChange={handleTabChange}
          aria-labelledby="station-assignment-tabs"
        >
          {tabs.map((tab) => (
            <Tab
              key={tab.id}
              value={tab.id}
              aria-controls={tab.id}
              id={tab.id}
            >
              {tab.label}
            </Tab>
          ))}
        </TabGroup>
      </Box>

      <div className="tab-content">{children}</div>
    </Box>
  );
};

export default StationAssignmentTabs;

import './StationAssignmentTabs.scss';